const CategoryProductAhan = [
    {
        ID: -1 , 
        ParentID: "",
        Name: "All Items",
    },
    {
        ID: 2001 , 
        ParentID: "",
        Name: "Profile",
    },
    {
        ID: 2002 , 
        ParentID: "",
        Name: "Angle Iron",
    },
    {
        ID: 2003 , 
        ParentID: "",
        Name: "I-beam",
    },
    {
        ID: 2004 , 
        ParentID: "",
        Name: "Rebar",
    },
    {
        ID: 2005 , 
        ParentID: "",
        Name: "Stainless Steel Sheet",
    },
    {
        ID: 2006 , 
        ParentID: "",
        Name: "Sheet",
    },
    {
        ID: 2007 , 
        ParentID: "",
        Name: "Pipe",
    },
    {
        ID: 2008 , 
        ParentID: "",
        Name: "Wire Products",
    },
]
export default CategoryProductAhan;
